module.exports = __webpack_public_path__ + "img/cleaf_banner5.2303e995.jpg";